<div fxLayout="row wrap" fxLayoutAlign="stretch">
  <div class="mini-block" fxFlex="100" fxLayout="column" style="max-width: 100%;">
    <!-- Block selected list items -->
    <mat-chip-list
      class="item-list like-mat-form-field"
      [ngClass]="{'disabled-field': disabled}"
      fxFlex="100"
      fxFlex.sm="100"
      fxFlex.xs="100"
      fxLayout="row wrap"
    >
      <span class="placeholder-label">{{ title }}</span>

      <div class="chips-wrapper" fxLayout="row wrap">
        <div class="chip-container" *ngFor="let block of blocks; index as i">
          <mat-chip-row *ngIf="block?.stock?.id === type?.id">
            {{
              block.start === block.end
                ? block.start + ""
                : block.start + "-" + block.end
            }}
            <button matChipRemove (click)="remove(i)" aria-label="'حذف'">
              <jam-icon
                color="warn"
                name="close"
                class="range-clear-icon"
              ></jam-icon>
            </button>
          </mat-chip-row>
        </div>
      </div>

      <button
        (click)="toggleInputOverlay()"
        fxLayoutAlign="center center"
        #addBtnOverlay
        class="add-btn"
        fxLayout="row"
      >
        <jam-icon name="plus" vertical-align="middle" [size]="18"></jam-icon>
      </button>

      <p class="on-overlay" *ngIf="overlayController && !touched">
        در کادرهای زیر، ابتدا و انتهای بازه صفحات و یا صفحه تک‌برگ دلخواه را
        وارد کنید و سپس روی دکمه افزودن کلیک کنید. شما می‌توانید چندین بازه و
        صفحه تک‌برگ انتخاب کنید.
      </p>
    </mat-chip-list>

    <div class="floated-add-input" @overlayFade *ngIf="overlayController" style="max-width: 100%;">
      <!-- range input-------------------------------- -->
      <form
        [formGroup]="overlayFormGroup"
        class="inputs"
        fxFlex="93"
        fxLayout="row wrap"
        fxLayoutAlign="center center"
      >
        <div class="block-add" fxFlex="100">
          <div class="d-flex">
            <mat-form-field appearance="fill">
              <mat-label>از صفحه</mat-label>
              <input
                formControlName="from"
                type="text"
                #fromPage
                matInput
                (keyup.enter)="add(+fromPage.value)"
              />
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>تا صفحه</mat-label>
              <input
                formControlName="to"
                type="text"
                #toPage
                matInput
                (keyup.enter)="add(+toPage.value)"
              />
            </mat-form-field>
          </div>
          <ng-lottie
            class="add-button"
            width="78px"
            height="78px"
            #lottieSingle
            [options]="addButtonOptions"
            (click)="add((fromPage.value || 0) + '-' + (toPage.value || 0))"
            (keyup.enter)="add((fromPage.value || 0) + '-' + (toPage.value || 0))"
            (animationCreated)="addAnimation('range', $event)"
            (mouseenter)="playAnimation('range')"
            (mouseleave)="stopAnimation('range')"
          ></ng-lottie>
        </div>

        <!-- Single page input-------------------------- -->
        <div class="single-block-add" fxFlex="100">
          <mat-form-field appearance="fill" fxFlex="100" style="width: 100%">
            <mat-label>تک برگ</mat-label>
            <input
              formControlName="single"
              #inputSingle
              type="number"
              matInput
              (keyup.enter)="add(+inputSingle.value)"
            />
          </mat-form-field>

          <ng-lottie
            class="add-button"
            width="78px"
            height="78px"
            #lottieSingle
            (click)="add(+inputSingle.value)"
            (onenter)="add(+inputSingle.value)"
            [options]="addButtonOptions"
            (animationCreated)="addAnimation('single', $event)"
            (mouseenter)="playAnimation('single')"
            (mouseleave)="stopAnimation('single')"
          ></ng-lottie>
        </div>
      </form>
    </div>
  </div>
</div>
